import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <main className="text-gray-900">
      <SEO 
        title="AlzijDigi | Pagina Niet Gevonden"
        description="De pagina die u zoekt bestaat niet. Ga terug naar de homepage of bekijk onze diensten."
        canonicalUrl="/404"
      />
      
      {/* 404 Hero Section */}
      <section className="min-h-screen flex items-center pt-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            {/* 404 Number */}
            <div className="mb-8">
              <h1 className="text-8xl md:text-9xl font-bold text-emerald-800 mb-4">404</h1>
              <div className="w-24 h-1 bg-emerald-800 mx-auto mb-8"></div>
            </div>
            
            {/* Main Message */}
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              {t('page_not_found')}
            </h2>
            
            <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
              {t('page_not_found_description')}
            </p>
            
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
              <Link
                to="/"
                className="bg-emerald-800 text-white px-8 py-4 text-lg font-semibold transition-all hover:bg-emerald-700 hover:scale-105"
              >
                {t('back_to_home')}
              </Link>
              
              <Link
                to="/diensten"
                className="border-2 border-emerald-800 text-emerald-800 px-8 py-4 text-lg font-semibold transition-all hover:bg-emerald-800 hover:text-white"
              >
                {t('view_services')}
              </Link>
            </div>
            
            {/* Helpful Links */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="p-6 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">{t('services')}</h3>
                <p className="text-sm text-gray-600 mb-3">{t('services_help_text')}</p>
                <Link to="/diensten" className="text-emerald-800 hover:underline text-sm">
                  {t('explore_services')} →
                </Link>
              </div>
              
              <div className="p-6 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">{t('about')}</h3>
                <p className="text-sm text-gray-600 mb-3">{t('about_help_text')}</p>
                <Link to="/over-ons" className="text-emerald-800 hover:underline text-sm">
                  {t('learn_more')} →
                </Link>
              </div>
              
              <div className="p-6 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">{t('contact')}</h3>
                <p className="text-sm text-gray-600 mb-3">{t('contact_help_text')}</p>
                <Link to="/contact" className="text-emerald-800 hover:underline text-sm">
                  {t('contact_us_404')} →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound; 